import styled from 'styled-components';

export const Text = styled.div<{ maxWidth?: string }>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
  width: 100%;
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex: 1;
`;

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #fff;
  width: 100%;
`;

export const TableContainer = styled.div`
  position: relative;
  margin-top: 12px;
  width: 100%;
  height: calc(100% - 77px - 32px);
  z-index: 1;

  > div.ant-table-wrapper {
    height: 100%;

    > div.ant-spin-nested-loading {
      height: 100%;

      > div.ant-spin-container {
        height: 100%;

        .ant-table {
          height: calc(100% - 24px);

          .ant-table-container {
            height: 100%;
          }

          .ant-table-selection-column {
            text-align: left;
          }
        }
      }
    }

    .ant-pagination {
      margin-bottom: 0;
    }
  }

  .disabled-row td > div {
    opacity: 0.4;
  }

  .disabled-row td > .operations {
    opacity: 1;
  }
`;
